import { tv } from '@change/ds-utils';

export const thumbnailStyles = tv({
	base: 'bg-transparent',
	variants: {
		variant: {
			sticker_icon: 'h-10 w-10',
			copied_link: 'h-12 w-12',
			paste: 'h-full w-[72px]',
			paste_url: 'h-full w-full',
			link_in_bio: 'h-full w-full',
			link_sticker: 'w-full',
		},
	},
});
